import React, { useCallback, useEffect, useMemo, useState } from 'react';
import moment from "moment";
import {
  EuiButton,
  EuiFormRow,
  EuiPopover,
  EuiSpacer,
  EuiDatePickerRange,
  EuiFieldNumber
} from '@elastic/eui';
import { DescargasAdapter } from '../../../../../infraestructure/persistence/rest/DescargasAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { downloadFile } from '../../../../../shared/utils/download';
import { MaskLoad } from '../../../components/Layout';
//import { useProfile } from '../../../../../shared/hooks/Profile';

export const SelectorDescargaCertificadosDesplazados = () =>{

    const api = new DescargasAdapter();
    const {resultError, exceptionError, launchNotification} = useNotifications();
    //const {profile} = useProfile();
    let [isLoading, setIsLoading] = useState(false);
	  let result;
    const fIni = moment().startOf('year');

    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const [ejercicio, setEjercicio] = useState(fIni.year());

    const onButtonClick = () =>
        setIsPopoverOpen((isPopoverOpen) => !isPopoverOpen);
    const closePopover = () => setIsPopoverOpen(false);

    const button = (
        <EuiButton size='s' iconType="arrowDown" iconSide="right" onClick={onButtonClick} fill style={{borderRadius:'0px',backgroundColor:'#ff8c00',borderColor:'#ff8c00'}}>
        {`Certificados 7P`}
        </EuiButton>
    );

    const MAX_EJERCICIO = useMemo(()=> fIni.year(),[fIni])

    const downloadFileCertificado = async (filter) => {
      setIsLoading(true)
      try {
        result = await api.DatosCertificadoDesplazados(filter);
        if(result.data && result.data!=="")
        {
          downloadFile(result.data,`Certificados7P_${filter.tipo}_${filter.anio}.xlsx`);
        }else{resultError()}
        setIsLoading(false)
      } catch (error) {
        let exception = ServerErrorMessage(error);
        exceptionError(exception)
        setIsLoading(false)
      }
    };

    const save = (tipo) =>{
      downloadFileCertificado({anio:ejercicio,tipo:tipo});
      closePopover();
  }

  const Mask = useMemo(()=>{return (<MaskLoad isLoading={isLoading}/>)},[isLoading])

    return (
      <>
        <EuiPopover
          ownFocus={false}
          button={button}
          isOpen={isPopoverOpen}
          closePopover={closePopover}
          initialFocus="[id=asdf2]">
          <EuiFormRow
            fullWidth
            label="Ejercicio"
            id="asdf"
            hasChildLabel={false}>
            <EuiFieldNumber value={ejercicio} onChange={(e)=>setEjercicio(parseInt(e.target.value))} max={MAX_EJERCICIO}/>
          </EuiFormRow>
          <EuiSpacer />
          <EuiButton style={{borderRadius:'0px',backgroundColor:'#ff8c00',borderColor:'#ff8c00'}} fullWidth fill size='s' onClick={()=>save(1)}>{`Certificados (I)`}</EuiButton>
          <EuiSpacer />
          <EuiButton style={{borderRadius:'0px',backgroundColor:'#ff8c00',borderColor:'#ff8c00'}} fullWidth fill size='s' onClick={()=>save(2)}>{`Certificados (II)`}</EuiButton>
        </EuiPopover>
        {Mask}
     </> 
      );
}